/**
 * Hotel specific fonts.
 *
 * Add the @font-face in src/index.scss and the body-class rule in
 * src/stylesheet/components/_hotelStyles.scss (e.g. `._784 { ... }`), then map
 * the hotel id here so antd components pick up the same family.
 */
export const HOTEL_FONTS = {
    784: "MuseoSansRounded, 'Montserrat', sans-serif",
};

export const getHotelFontFamily = (hotelDetails = {}) => {
    if (hotelDetails?.custom_font) {
        return hotelDetails.custom_font;
    }
    return HOTEL_FONTS[hotelDetails?.id] || null;
};
